import { MutationTree } from "vuex";
import { ProcessOperationImplementationState, ProcessOperationImplementation } from "./model";

const mutations: MutationTree<ProcessOperationImplementationState> = {
  setProcessOperationImplementations(state, processOperationImplementations: ProcessOperationImplementation[]) {
    state.processOperationImplementations = processOperationImplementations
  },
  addProcessOperationImplementation(state, processOperationImplementation: ProcessOperationImplementation) {
    state.processOperationImplementations.push(processOperationImplementation)
  },
  updateProcessOperationImplementation(state, processOperationImplementation: ProcessOperationImplementation) {
    const c = state.processOperationImplementations.find(c => c.id === processOperationImplementation.id);
    Object.assign(c, processOperationImplementation);
  },
  deleteProcessOperationImplementation(state, id: string) {
    state.processOperationImplementations = state.processOperationImplementations.filter(processOperationImplementation => processOperationImplementation.id !== id)
  }
}

export default mutations;
